import { Pagination as AntdPagination, PaginationProps } from 'antd';
import classNames from 'classnames';
import { FC } from 'react';

import { Icon } from '../Icon/Icon';

import './Pagination.scss';

interface Props extends PaginationProps {
  className?: string;
  containerClassName?: string;
  total?: number;
}

export const Pagination: FC<Props> = ({ containerClassName, total = 500, className, ...restProps }) => {
  return (
    <div data-testid="pagination-container" className={classNames('custom-pagination', containerClassName)}>
      <AntdPagination
        {...restProps}
        total={total}
        defaultPageSize={10}
        showSizeChanger={false}
        className={classNames('custom-pagination__pagination', className)}
        data-testid="pagination"
        nextIcon={<Icon name="chevron_right" />}
        prevIcon={<Icon name="chevron_left" />}
        jumpNextIcon="..."
        jumpPrevIcon="..."
      />
    </div>
  );
};
